import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Button from "../UI/ActionButton";
import IconComponent from "../Icons";
import { CancelarButton, EnviarButton } from "./styles";
import { Navigate, useNavigate } from "react-router-dom";

function SubmitForm({onEnviar, onSave, onCancel, onVoltar, labelEnviar = "➤ Enviar"}){
    const navigate = useNavigate();

    const onSalvar = async() => {
        let returnFunction = await onSave()
        
        if (!returnFunction && returnFunction !== undefined){
            return
        }

        if (typeof onCancel !== 'function'){
            onCancelDefault()
        }
    }

    const onSend = async() => {
        let returnFunction = await onEnviar()
        
        if (!returnFunction && returnFunction !== undefined){
            return
        }

        if (typeof onCancel !== 'function'){
            onCancelDefault()
        }
    }

    const onCancelDefault = () => {
        if (typeof onCancel === 'function'){
            onCancel()
        }else{
            const caminho = retCaminho()
    
            navigate(caminho, { relative: "path" });
        }
    }

    const onVoltarDefault = () => {
        if (typeof onVoltar === 'function'){
            onVoltar()
        }else{
            const caminho = retCaminho()
            
            navigate(caminho, { relative: "path" });
        }
    }

    const retCaminho = () => {
        const caminho = window.location.pathname
        const isVisualizar = window.location.pathname.includes('Visualizar')
        const isAlterar = window.location.pathname.includes('Alterar')
        const isIncluir = window.location.pathname.includes('Incluir')
        const isCopiar = window.location.pathname.includes('Copiar')
        let index
        
        if ( isVisualizar ){
            index = caminho.indexOf('/Visualizar');
        }
        if ( isAlterar ){
            index = caminho.indexOf('/Alterar');
        }
        if ( isIncluir ){
            index = caminho.indexOf('/Incluir');
        }
        if (window.location.pathname.includes('Mapa') ){
            index = caminho.indexOf('/Mapa');
        }
        if ( isCopiar ){
            index = caminho.indexOf('/Copiar');
        }
        else if (window.location.pathname.includes('Contatos') && !(isVisualizar || isAlterar || isIncluir)){
            index = caminho.indexOf('/Contatos');
        }

        return caminho.substring(0, index);
    }

    return (
        <Row className="d-flex align-content-end align-items-end justify-content-end" style={{ rowGap: "12px" }}>
            { onEnviar && (
                <Col md="2" xs="12" >
                    <EnviarButton variant="primary" type="submit" onClick={onSend} className="w-100">
                        {labelEnviar}
                    </EnviarButton>
                </Col>
            )}
            { onSave && (
                <Col md="2" xs="12" >
                    <Button variant="success" type="submit" onClick={onSalvar} className="w-100">
                        <IconComponent icon="AiOutlineSave" /> <span>Salvar</span>
                    </Button>
                </Col>
            )}
            { onCancel && (
                <Col md="2" xs="12" >
                    <Button variant="danger" type="submit" onClick={onCancelDefault} className="w-100">
                        <IconComponent icon="AiOutlineClose" /> <span>Cancelar</span>
                    </Button>
                </Col>
            )}
            { onVoltar && (
                <Col md="2" xs="12" >
                    <Button variant="light" type="submit" onClick={onVoltarDefault} className="w-100">
                        <IconComponent icon="AiOutlineArrowLeft" /> <span>Voltar</span>
                    </Button>
                </Col>
            )}
        </Row>
    );
}

export default SubmitForm;